module.exports = __webpack_public_path__ + "media/images/home-bg-320-444e2472cdbb43ebb647e809a8ee6372.png";